import { buildPricingOptionsForMarket, PricingOption } from '@/enterprise/components/OfferBuilder/utils';
import { CombinedPricingSuggestion } from '@/enterprise/data/usePricingSuggestion';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import localeRateToDomain from '@/utils/localeRateToDomain';

export type RateType = 'APR' | 'DISC';

export type { PricingOption };

export interface SelectedStrategy {
  type: 'trendingRate' | 'expressAccept' | 'nameYourRate';
  rate: number;
  rateType: RateType;
  pricingRateUuid?: string;
}

// builds pricing options array from pricing data for a single taker market
export const buildOptionsFromPricingData = ({
  pricingData,
  takerMarket,
  selectedRateType,
  frequency = 'recurring',
}: {
  pricingData: CombinedPricingSuggestion | null;
  takerMarket: TakerMarket;
  selectedRateType: RateType;
  frequency?: 'oneTime' | 'recurring';
}): PricingOption[] =>
  buildPricingOptionsForMarket({ pricingData, takerMarket, rateType: selectedRateType, frequency });

// parses a rate input string without validation
// returns the rate in percentage format (0.12 = 0.12%) or null if not a valid number
// accepts zero and negative values - validation should happen at submit time
export const parseRateInput = (value: string): number | null => {
  const domainRateStr = localeRateToDomain(value);
  const domainRate = domainRateStr ? parseFloat(domainRateStr) : null;
  return domainRate !== null && !isNaN(domainRate) ? domainRate : null;
};
